document.addEventListener("DOMContentLoaded", () => {
  document.documentElement.classList.add("js-animate");

  document.querySelector("[data-menu-toggle]")?.addEventListener("click", (event) => {
    const nav = document.querySelector("[data-nav]");
    if (!nav) return;
    const isOpen = nav.classList.toggle("is-open");
    event.currentTarget.setAttribute("aria-expanded", String(isOpen));
  });

  document.querySelectorAll("[data-product-thumb]").forEach((button) => {
    button.addEventListener("click", () => {
      const target = document.querySelector("[data-main-product-image]");
      if (!target) return;
      target.src = button.dataset.productThumb;
      document.querySelectorAll("[data-product-thumb]").forEach((item) => item.classList.remove("is-active"));
      button.classList.add("is-active");
    });
  });

  const revealItems = document.querySelectorAll(".hero-copy, .hero-media, .section, .product-card");
  if ("IntersectionObserver" in window) {
    revealItems.forEach((item) => item.classList.add("reveal-on-scroll"));
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add("is-visible");
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.12 });
    revealItems.forEach((item) => observer.observe(item));
  } else {
    revealItems.forEach((item) => item.classList.add("is-visible"));
  }
});
